module.exports = __webpack_public_path__ + "img/5S.c771a018.png";